// src/components/weeklyAwards/useWeeklyAwardsSet.js
// Anasayfa / sezon sayfası için en son yayınlanan "Haftanın Enleri" setini tek
// seferde çeker. Haftanın Enleri sezon bazlıdır: sezon seçiliyse yalnızca o
// sezonun seti gösterilir. Hem bireysel ödül şeridi hem de haftanın karması
// sahası aynı veriyi paylaşır.
import { useEffect, useState } from "react";
import marketValueApi from "../../api/marketValueApi";

export default function useWeeklyAwardsSet(cityId, { seasonId, leagueId } = {}) {
  const [set, setSet] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!cityId) {
      setSet(null);
      setState("empty");
      return undefined;
    }
    let alive = true;
    setState("loading");
    const params = { cityId, limit: 1 };
    if (seasonId) params.seasonId = seasonId;
    if (leagueId) params.leagueId = leagueId;
    marketValueApi
      .weeklyPublic(params)
      .then((res) => {
        if (!alive) return;
        const first = (res.items || [])[0] || null;
        setSet(first);
        setState(first ? "ready" : "empty");
      })
      .catch(() => alive && setState("empty"));
    return () => {
      alive = false;
    };
  }, [cityId, seasonId, leagueId]);

  return { set, state };
}
